module.exports = __webpack_public_path__ + "static/media/hold_color.75fb06cb.svg";